import { TypographyMuted } from "@/components/ui/typography"
import useDisclosure from "@/hooks/useDisclosure"
import { CircleArrowLeft, Home, Megaphone, MessageCirclePlus, Save } from "lucide-react"
import AddProductMarketResearchDialog from "../AddProductMarketResearchDialog" 
import { useOffline } from "@/context/OfflineContext"
import { MarketResearch, ResearchedProduct } from '@/types/MarketResearch'
import ProductsOfflineDialog from "../ProductsOfflineDialog"  
import CardsResearchedProducts from "./components/CardsResearchedProducts"
import ViewImageDialog from "../ViewImageDialog"
import { useEffect, useState } from "react"
import { useImageResearchedProductQuery } from "@/queries/useImageResearchedProductQuery"
import Lottie from 'lottie-react'
import Money from '@/assets/lottie/Insider-loading.json'
import EditProductMarketResearchDialog from "../EditProductMarketResearchDialog"
import DeleteProductMarketResearchDiaload from "../DeleteProductMarketResearchDiaload"
import Button from '@/components/Button'
import AddNewProductInProductMarketResearchDialog from "./components/AddNewProductInProductMarketResearchDialog"
import { Link, useNavigate } from "react-router-dom"


interface props {
    marketResearch: MarketResearch,
    dataResearchedProducts: ResearchedProduct[]

}

const AgentLayout = ({marketResearch, dataResearchedProducts}: props) => {   
    const { data } = useOffline(); 
    const [status, setStatus] = useState(false)
    const [keyImage, setkeyImage] = useState<string>('')
    const [srcImage, setSrcImage] = useState<string>('')
    const [selectProduct, setSelectProduct] = useState<ResearchedProduct>()
    const navigate = useNavigate();

    const {
        isOpen: isOpenAddProduct,
        onClose: onCloseAddProduct,
        onOpen: onOpenAddProduct
    } = useDisclosure()

    const {
        isOpen: isOpenEditProduct,
        onClose: onCloseEditProduct,
        onOpen: onOpenEditProduct
    } = useDisclosure()

      const {
        isOpen: isOpenDeleteProduct,
        onClose: onCloseDeleteProduct,
        onOpen: onOpenDeleteProduct
    } = useDisclosure()
 
    const {
        isOpen: isOpenProductOffline,
        onClose: onCloseProductOffline,
        onOpen: onOpenProductOffline
    } = useDisclosure()

    const {
        isOpen: isOpenViewImage,
        onClose: onCloseViewImage,
        onOpen: onOpenViewImage
    } = useDisclosure()

    const {
        isOpen: isOpenAddNewProduct,
        onClose: onCloseAddNewProduct,
        onOpen: onOpenAddNewProduct
    } = useDisclosure()

    const { data: dataImage, isFetching } = useImageResearchedProductQuery(keyImage, status)

   
    const handleViewImage = (key: string) => {
        setkeyImage(key)
        setStatus(true)
    }

    const handleEditProduct = (productResearched: ResearchedProduct) => {
        setSelectProduct(productResearched)
        onOpenEditProduct()
    } 

    const handleDeleteProduct = (productResearched: ResearchedProduct) => {
        setSelectProduct(productResearched)
        onOpenDeleteProduct()
    } 

    useEffect(() => {
        if(dataImage) {
            setSrcImage(dataImage.url)
            onOpenViewImage()
        } 
    }, [dataImage, keyImage]); 
    
 
   
    return (
        <div className="flex flex-col h-full overflow-auto py-4 bg-gray-50"> 

            <nav className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-sidnav-400 md:hidden">
                <div className="grid [grid-template-columns:repeat(auto-fit,minmax(0,1fr))] items-center h-16">
                    <div className="flex justify-center">
                        <Link className="flex flex-col items-center text-xs text-white" to={'/'}> 
                            <Home size={18} />
                            <TypographyMuted className="text-white">Inicio</TypographyMuted> 
                        </Link>
                    </div> 
                    <div className="flex justify-center">
                        <button className="flex flex-col items-center text-xs text-white" onClick={() => navigate(-1)}>
                            <CircleArrowLeft size={18} />
                            <TypographyMuted className="text-white">Voltar</TypographyMuted> 
                        </button>
                    </div> 
                    {marketResearch.DD_STATUS == 'Publicado' && (
                        <>
                            <div  className="flex justify-center">
                                <button className="flex flex-col items-center text-xs text-white" onClick={() => onOpenAddProduct()}>
                                    <MessageCirclePlus size={18}/>
                                    <TypographyMuted className="text-white">Informar</TypographyMuted> 
                                </button>
                            </div> 
                            <div className="flex justify-center">
                                <button className="flex flex-col items-center text-xs text-white" onClick={() => onOpenAddNewProduct()}> 
                                    <Megaphone size={18} />
                                    <TypographyMuted className="text-white">Novo</TypographyMuted> 
                                </button>
                            </div>  
                            {data.ProductsFromCustomer?.length > 0 && (
                                <div  className="flex justify-center">
                                        <button className="flex flex-col items-center text-xs text-white"  onClick={() => onOpenProductOffline()}>
                                            <div className="flex gap-2 text-white"> 
                                                <Save size={18} />
                                                <div
                                                className={`px-2 rounded-full text-xs font-medium bg-orange-300`}
                                                >
                                                    {data.ProductsFromCustomer.length}
                                                </div>
                                            </div>
                                            <TypographyMuted className="text-white">Salvar </TypographyMuted> 
                                        </button>
                                </div> 
                            )}
                        </>
                    )}
                    
                </div>
            </nav>
            <nav className="hidden md:block sticky">
                <div className="flex gap-4 items-center h-16"> 
                    <div  className="flex justify-center">
                        <Button className="flex items-center gap-2 text-xs" onClick={() => onOpenAddProduct()}> 
                            <TypographyMuted className="text-white">Informar</TypographyMuted> 
                        </Button>
                    </div> 
                    <div  className="flex justify-center">
                        <Button className="flex items-center gap-2 text-xs" onClick={() => onOpenAddNewProduct()}> 
                            <TypographyMuted className="text-white">Novo</TypographyMuted> 
                        </Button>
                    </div> 
                    <div  className="flex justify-center">
                        {data.ProductsFromCustomer?.length > 0 && (
                            <Button className="flex items-center text-xs gap-2"  onClick={() => onOpenProductOffline()}>
                                <TypographyMuted className="text-white">Salvar </TypographyMuted> 
                                <div className="flex gap-2 ">  
                                    <div className={`text-xs font-medium text-orange-500`}>
                                       ( {data.ProductsFromCustomer.length} )
                                    </div>
                                </div>
                            </Button>
                        )}
                    </div> 
                </div>
            </nav>

            <div className="grid md:grid-cols-2 lg:md:grid-cols-3 gap-3"> 
                {dataResearchedProducts?.map((item, index) => (
                    <CardsResearchedProducts 
                        key={index} 
                        dataResearchedProducts={item} 
                        marketResearch={marketResearch} 
                        handleViewImage={handleViewImage} 
                        handleEditProduct={handleEditProduct}
                        handleDeleteProduct={handleDeleteProduct}
                    />
                ))} 
            </div> 

            {isFetching && (
                <div className="absolute flex top-0 left-0 items-center justify-center w-screen h-screen z-50 bg-[#ffffff82]">
                    <Lottie animationData={Money} className="md:w-1/4" />
                </div>
            )}
            {selectProduct && (
                <EditProductMarketResearchDialog 
                    isOpen={isOpenEditProduct}
                    onClose={onCloseEditProduct} 
                    itemEdit={selectProduct}
                    handleViewImage={handleViewImage} 
                />
            )}

            {selectProduct && (
                <DeleteProductMarketResearchDiaload
                    dataResearchedProducts={selectProduct}
                    isOpen={isOpenDeleteProduct}
                    onClose={onCloseDeleteProduct} 
                />
            )}

            <AddProductMarketResearchDialog 
                isOpen={isOpenAddProduct} 
                onClose={onCloseAddProduct}  
                MarketResearch={marketResearch}
            />

            <AddNewProductInProductMarketResearchDialog 
                isOpen={isOpenAddNewProduct}
                onClose={onCloseAddNewProduct}
                MarketResearch={marketResearch}
            />

            <ProductsOfflineDialog 
                isOpen={isOpenProductOffline} 
                onClose={onCloseProductOffline} 
            />
            
            {srcImage && (
                <ViewImageDialog 
                   isOpen={isOpenViewImage} 
                   onClose={onCloseViewImage} 
                   src={srcImage}
               />
            )}
        </div>
    )
}

export default AgentLayout
